module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/Direction/images/direction-B-lvl1-75.f69de2d5.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/Direction/images/direction-B-lvl1-75.png
// module id = 3379
// module chunks = 11